export const relevance = { value: 'relevancy,true', label: 'Relevance' };
export const view = { value: 'sys_view_count,true', label: 'Views' };

export const firstPage = 1;

export type SearchParamsType = {
  page?: number;
  textSearch?: string;
  orderBy?: string;
  options?: object;
};
